import { Article as Ar } from "../helper/interfaces";
import React, { useState } from "react";
import { formattedDateArticle } from "../helper/timeHelper";
import { loadCommentsClientSide, postCommentsClientSide } from "../helper/api";
import { commentsPageSize } from "../pages/api/comments/[id]/[page]";
import { useUser } from "../lib/useUser";
import { Send } from "react-feather";
import parse, { HTMLReactParserOptions } from "html-react-parser";
import { Element } from "domhandler";

interface Data {
  entry: Ar;
}

function Comments(data: Data) {
  const [user] = useUser();
  const tokenId = user?.tokenId || undefined;
  const [resultText, setResultText] = useState("");

  const article = data.entry;
  const [loadedComments, setLoadedComments] = useState(article.objectComments);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(2);

  const displayComments =
    article.objectComments && article.objectComments.disableComments == false;
  const commentsCount = article.objectComments?.commentsCount;
  const commentsCountString =
    commentsCount > 1
      ? `${commentsCount} Kommentare`
      : commentsCount === 1
      ? "1 Kommentar"
      : "Keine Kommentare";

  const [loadMore, setLoadMore] = useState(commentsCount > commentsPageSize);

  const loadMoreComments = async () => {
    setIsLoadingMore(true);

    // load more data merge
    let moreComments = await loadCommentsClientSide(article.id, page);

    setIsLoadingMore(false);

    if (moreComments) {
      setPage(page + 1);

      if (moreComments.length < commentsPageSize) {
        setLoadMore(false);
      }

      const a = loadedComments.comments.concat(moreComments);
      setLoadedComments({
        ...loadedComments,
        comments: a,
      });
    } else {
      setLoadMore(false);
    }
    return false;
  };

  const [comment, setComment] = useState("");

  const handleInput = (e) => {
    setComment(e.target.value);
  };

  const handlePostComment = async () => {
    if (!comment) return;
    const result = await postCommentsClientSide(article.id, comment, tokenId);
    if (result?.text) {
      setResultText(result?.text);
      // setTimeout(() => {
      //   setResultText('')
      // }, 5000)
    }
    setComment("");
  };

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (
        domNode instanceof Element &&
        domNode.attribs &&
        domNode.attribs.href
      ) {
        domNode.attribs.target = "_blank";
      }
    },
  };

  return (
    <React.Fragment>
      {displayComments && (
        <div key={`comment-article-${article.id}`} className="comments">
          <div className="comments-meta">
            <div className="comments-count">
              <span>{commentsCountString}</span>
            </div>
            <div className="comments-hint">
              {resultText && (
                <div className="mb-2">{parse(resultText, options)}</div>
              )}
              {!tokenId && (
                <div className="comments-hint-text">
                  Um selbst einen Kommentar abgeben zu können, müssen Sie sich
                  einloggen oder sich vorher registrieren.
                </div>
              )}
              {tokenId && (
                <>
                  <textarea
                    value={comment}
                    onChange={handleInput}
                    className="textarea"
                    id="comment-text"
                    rows={6}
                />
                  <button
                    className="comments-input__action btn btn-primary"
                      onClick={handlePostComment}
                    aria-label="Kommentar absenden"
                  >
                    Kommentar schreiben
                  </button>
                </>
              )}
            </div>
          </div>
          <div
            key={`comment-comments-section-${article.id}`}
            className="comments-section"
          >
            {loadedComments &&
              loadedComments.comments.map((c, index) => (
                <>
                  <div
                    className="comment"
                    key={`comment-${index}-${article.id}`}
                  >
                    <div
                      className="comment-meta"
                      key={`comment-meta-${index}-${article.id}`}
                    >
                      <div
                        className="comment-author"
                        key={`comment-author-${index}-${article.id}`}
                      >
                        {c.author}
                      </div>
                      <div
                        className="comment-date"
                        key={`'comment-date-${index}-${article.id}`}
                      >
                        {" "}
                        {c.date && formattedDateArticle(c.date)}
                      </div>
                    </div>
                    <div
                      className="comment-text"
                      key={`comment-text-${index}-${article.id}`}
                    >
                      {c.text}
                    </div>
                  </div>
                </>
              ))}
            {loadMore && (
              <button
                className="teasers__more__btn btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  loadMoreComments();
                }}
              >
                Weitere Kommentare
              </button>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default Comments;
